module.exports = __webpack_public_path__ + "img/client-say-2.03e498e8.png";